module.exports = require("zlib");


//////////////////
// WEBPACK FOOTER
// external "zlib"
// module id = 151
// module chunks = 0